export const debounce = (func, wait, immediate) => {
  let timeout;

  return () => {
    const context = this;
    const args = arguments;

    const later = () => {
      timeout = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
};

export const rafThrottle = fn => {
  let ticking = false;

  return (...props) => {
    if (!ticking) {
      window.requestAnimationFrame((timestamp) => {
        fn(...props, timestamp);
        ticking = false;
      });

      ticking = true;
    }
  };
};
